<motn-drawer-gap-from-top
  (clickedOutside$)="clickedOutside.emit($event)"
>
  <h3>
    @if (displayIcon) {
      <div
        class="icon"
        [innerHtml]="'<i class=\'fa-regular fa-'+displayIcon+'\'>'"
      ></div>
    }

    {{displayName}}
  </h3>

  <div
    class="tile-grid"
  >
    @for (childTile of childTiles; track childTile.ID) {
      <motn-tile
        [rawTile]="childTile"
      ></motn-tile>
    }
  </div>
</motn-drawer-gap-from-top>
